import CryptoJS from 'crypto-js'
import md5 from 'crypto-js/md5'
import { LOCAL_QUES_ANSWERS } from '@/constants'
import dayjs from 'dayjs'
import UPNG from 'upng-js'
import duration from 'dayjs/plugin/duration'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')
dayjs.extend(duration)

// 获取地址栏中的参数
export function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  // 取#号后边的
  const tmp = window.location.href.split('#')[1]
  if (!tmp) return null
  let r = tmp.split('?')
  if (r[1]) {
    r = r[1].match(reg)
  } else {
    return null
  }
  let context = ''
  if (r !== null) context = r[2]
  reg = null
  r = null
  return context === null || context === '' || context === 'undefined'
    ? ''
    : context
}

// 判断是否是在微信浏览器里
export function isWeixinBrowser() {
  return /micromessenger/i.test(navigator.userAgent)
}

// 生成随机字符串
const randomStr = (
  length = 8,
  chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
) => {
  var result = ''
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)]
  return result
}

// 生成验签参数
export const generateSign = (config) => {
  const noncestr = randomStr()
  const timestamp = Math.floor(new Date().getTime() / 1000)
  const orgid = config.orgId || 29
  const secret = config.secret
  const path = config.path || ''

  const sign = md5(
    path + noncestr + timestamp + config.orgId + secret
  ).toString()

  return {
    noncestr,
    timestamp,
    sign,
    orgid,
  }
}

// 加密
export function encrypt(word) {
  if (!word) return ''
  return CryptoJS.AES.encrypt(
    word,
    CryptoJS.enc.Utf8.parse('c19f71d91a0d419987b5f9cdc1616dc6'),
    {
      iv: CryptoJS.enc.Utf8.parse('0000000000000000'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  ).toString()
}

// 判断是否在app里
export function isInApp() {
  const ua = navigator.userAgent
  if (ua.indexOf('chuangqi') !== -1) {
    return true
  }
  return false
}

// 是否是少儿频道定制
export function isChildrenChannel(questionActiveKey) {
  const childrenChannel = [
    // 2023-11-15 少儿频道-国学小名士 首页定制
    '5561a980be0d47b8ae37ed0577e7755c',
    // 开发测试用
    'f855cf36e0354a7aaeeca47fe4bd0de8',
    // 2024-7-1 少儿频道-国学小名士 首页定制
    '6128399304d94a3c9e7ec1348418d2c8'
  ]

  return childrenChannel.includes(questionActiveKey)
}

// 毫秒转时间
export function formatDuring(mss) {
  return dayjs
    .duration(mss, 'milliseconds')
    .format('DD天HH小时mm分ss秒')
    .replace(/00天/, '')
    .replace(/00小时/, '')
    .replace(/00分/, '')
    .replace(/00秒/, '')
}

// 毫秒转时间
export function formatDuringNoDecimal(mss) {
  return dayjs
    .duration(mss, 'milliseconds')
    .format('DD天HH小时mm分ss秒')
    .replace(/00天/, '')
    .replace(/00小时/, '')
    .replace(/00分/, '')
    .replace(/00秒/, '')
}

// 自定义登录加密
export function encryptDiy(word) {
  if (!word) return ''
  return CryptoJS.AES.encrypt(
    word,
    CryptoJS.enc.Utf8.parse('5374113a5aea413eaeffca87443cf0d0'),
    {
      iv: CryptoJS.enc.Utf8.parse('0000000000000000'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  ).toString()
}

// 获取list中匹配的答案
export function getAnswer(questionKey) {
  try {
    const list = JSON.parse(localStorage.getItem(LOCAL_QUES_ANSWERS))
    const result = list.filter((item) => item.questionKey === questionKey)
    return result[0]?.answers
  } catch (error) {
    return undefined
  }
}

// 压缩png图片通过 UPNG.js
export function compressPng(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = function (event) {
      let arrayBuffer = event.target.result

      // 使用 UPNG.js 解码图片
      let decoded = UPNG.decode(arrayBuffer)
      let rgba = UPNG.toRGBA8(decoded)[0]

      // 使用 UPNG.js 压缩图片
      let compressed = UPNG.encode([rgba], decoded.width, decoded.height, 255)

      // 将结果转换为 File 对象
      let file = new File([compressed], 'compressed.png', { type: 'image/png' })
      resolve(file)
      // 你现在可以使用这个 File 对象了，例如将它保存到文件或者在网页中显示
    }
    reader.readAsArrayBuffer(file)
  })
}

// 是否是h5
export function isMobile() {
  let flag =
    /(chuangqi|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
      navigator.userAgent
    )
  return flag
}

// 判断是否是图片
export function isImage(str) {
  const reg = /\.(png|jpg|gif|jpeg|webp)$/
  return reg.test(str)
}

// 判断是否是视频
export function isVideo(str) {
  return /\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4|MOV|MP4)$/.test(
    str.trim()
  )
}

// 判断是否超出限制
export function handleFormatlimitTips(chance) {
  if (typeof chance !== 'number') return
  if (chance !== null) {
    if (chance <= 0) {
      return '（已选满）'
    }
    return `（剩余可选${chance}次）`
  }
}

// base64转file
export function dataURLtoFile(base64Str, fileName = '证书.png') {
  const arr = base64Str.split(',')
  const bstr = atob(arr[1]) // 对base64串进行操作，去掉url头，并转换为byte   atob为window内置方法
  let len = bstr.length
  const ab = new ArrayBuffer(len) // 将ASCII码小于0的转换为大于0
  const u8arr = new Uint8Array(ab) //
  while (len--) {
    u8arr[len] = bstr.charCodeAt(len)
  }
  // 创建新的 File 对象实例[utf-8内容，文件名称或者路径，[可选参数，type：文件中的内容mime类型]]
  const file = new File([u8arr], fileName, {
    type: 'image/png',
  })

  return file
}
